import { Component, OnInit } from '@angular/core';
import { PageBase } from '../../base/page-base/page-base.component';

@Component({
    templateUrl: 'forbidden.page.html',
    selector: 'forbidden-page',
    standalone: false,
})
export class ForbiddenPage extends PageBase implements OnInit {
    public headerText: string;

    //TODO LATER: https://freefrontend.com/403-forbidden-html-templates/
    public ngOnInit(): void {
        this.headerText = this.settings.applicationShortNameWithVersion;
    }
}
